export enum HttpRequestHeader {
	DoNotToastValidationErrors = 'DoNotToastValidationErrors',
	Authorization = 'Authorization',
}
